export enum Event {
  SETTINGS_UPDATED = "settings updated",
}
